import { createSlice } from "@reduxjs/toolkit";
import {
  fetchMachinarys,
  fetchMachinarysById,
  updateStatusInMachinary,
  updateMachinary,
  fetchAllDropdowns,
  exportMachinarysCSV,
  fetchAllDropdownsMachinarys,
} from "./thunk";

interface MachinarysState {
  machinaryList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  orgDropDown: any[];
  departmentDropDown: any[];
  orgCityDropDown: any[];
  machinarysDropDown: any[];

  dropdownOptions: Record<string, any[]>;
}

const initialState: MachinarysState = {
  machinaryList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  exportCSVLoading: false,
  exportCSVError: null,
  dropdownOptions: {},
  orgDropDown: [],
  departmentDropDown: [],
  orgCityDropDown: [],
  machinarysDropDown: [],
};

const machinarySlice = createSlice({
  name: "machinarys",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Machinarys
      .addCase(fetchMachinarys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMachinarys.fulfilled, (state, action) => {
        state.loading = false;
        state.machinaryList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchMachinarys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch machinarys";
      })

      // Fetch Single Machinary by ID
      .addCase(fetchMachinarysById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchMachinarysById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Machinary
      .addCase(updateMachinary.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.machinaryList = state.machinaryList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateMachinary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update machinary";
      })

      // Update Status
      .addCase(updateStatusInMachinary.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.machinaryList = state.machinaryList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateStatusInMachinary.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to update machinary status";
      })
      .addCase(exportMachinarysCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportMachinarysCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportMachinarysCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to export CSV";
      })
      .addCase(fetchAllDropdownsMachinarys.fulfilled, (state, action) => {
        state.orgDropDown = action.payload.orgDropDown || [];
        state.departmentDropDown = action.payload.departmentDropDown || [];
        state.machinarysDropDown = action.payload.machinarysDropDown || [];
      });
  },
});

export default machinarySlice.reducer;
